import { Component, OnInit } from '@angular/core';
import { ConfigService } from '../../../core/services/config.service';

@Component({
    selector: 'app-need-assistance-card',
    templateUrl: './need-assistance-card.component.html',
    styleUrls: ['./need-assistance-card.component.scss'],
    standalone: false
})
export class NeedAssistanceCardComponent implements OnInit {

  supportEmail: string;
  needAssistance: any;

  constructor(
    private configService: ConfigService
  ) {
    this.supportEmail = this.configService.supportEmail;
  }

  ngOnInit() {
    this.needAssistance = {
      name: 'Need Assistance?',
      description: 'Send email to: <a href="mailto:' + this.supportEmail +
        '" title="Click here to send email to Partner Center Support">Partner Center Support</a>',
      title: 'Click here to send email to Partner Center Support',
      image: '../assets/images/question-circle.png',
      url: 'javascript:void(0)'
    };
  }

}
